import React, { useState } from 'react';
import { Menu, Space } from 'antd';
import { useNavigate } from 'react-router-dom';

export function getItem(label, key, icon, children, type, url) {
  return {
    key,
    icon,
    children,
    label,
    type,
    url,
  }
}

const rootSubmenuKeys = ['sub1', 'sub2', 'sub4'];
const App = ({ items }) => {
  const [openKeys, setOpenKeys] = useState(['sub1']);

  const navigate = useNavigate();

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const onItemClick = (item) => {
    const key = item.key;

    // Return the item that matches the key of children
    const foundItem = items.reduce((acc, curr) => {
      if (acc) return acc; // If item is already found, return it

      if (curr.children) {
        const foundChild = curr.children.find((child) => child.key === key);
        if (foundChild) return foundChild;
      }

      return curr.key === key ? curr : null;
    }, null);

    if (foundItem.url) {
      navigate(`/admin/${foundItem.url}`);
    }
  };

  return (
    <Menu
      mode="inline"
      openKeys={openKeys}
      onOpenChange={onOpenChange}
      onClick={onItemClick}
      style={{
        width: 256,
      }}
      items={items}
    />
  );
};
export default App;